var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.735 76.5144C60.943 76.5144 76.5142 60.9432 76.5142 41.7352C76.5142 22.5272 60.943 6.95605 41.735 6.95605C22.527 6.95605 6.95582 22.5272 6.95582 41.7352C6.95582 60.9432 22.527 76.5144 41.735 76.5144Z",
    fill: "#04C200",
    stroke: "#04C200",
    strokeWidth: 6.95583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3012 41.7361L38.2571 48.6919L52.1687 34.7803",
    stroke: "white",
    strokeWidth: 6.95583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.f52cf890bfaef1ef155da008b69ff022.svg";
export { ForwardRef as ReactComponent };